import { DevTools } from 'jotai-devtools';
import css from 'jotai-devtools/styles.css?inline';

export const JotaiDevTools = () =>
  import.meta.env.VITE_ENABLE_JOTAI_DEVTOOLS === 'true' ? (
    <>
      <style>{css}</style>
      <DevTools />
    </>
  ) : null;
